import { KatTextarea } from '@amzn/katal-react';
import React from 'react';
import styled from 'styled-components';

export interface TextAreaProps extends KatTextarea._OwnProps {
  onTextAdded: (text: string) => void;
}

const TextEditingArea = styled.div`
  kat-textarea {
    width: 100%;
    max-width: 100%;
    font-size: ${(props) => props.theme.fontSize.m};
    --height: 15vh;
    --border-color: ${(props) => props.theme.colors.Submarine};
    --font-size: ${(props) => props.theme.fontSize.m};
  }
`;

const TextArea: React.FC<TextAreaProps> = ({
  label,
  value,
  onTextAdded,
  maxlength,
  disabled,
  ...props
}) => {
  return (
    <TextEditingArea>
      <KatTextarea
        disabled={disabled}
        label={label}
        value={value}
        onInput={(e) => onTextAdded(e.currentTarget.value)}
        maxlength={maxlength}
        {...props}
      />
    </TextEditingArea>
  );
};

export default TextArea;
